import { HTTP_TOKEN } from "./http";


export const getUser = () => {
    return HTTP_TOKEN.get("user").then(result => {
      return result.data;
    });
  };

export const AccountsList = () => {
    return HTTP_TOKEN.get("user/accounts").then(result => {
      return result.data;
    });
  };


  export const updateUser = (data) => {
    return HTTP_TOKEN.put("user", data).then(result => {
      return result.data;
    });
  };
